import React from "react";
import { connect } from "react-redux";
import { Div } from "components/Base";
import * as R from "ramda";
import {
  actions as homeActions,
  getters as homeGetters
} from "Portal/NewPortal/PortalHome/model";
import { noop } from "utils/General";
import Avatar from "Portal/NewPortal/Shared/Avatar";
import * as PortalSelectors from "redux/modules/portal/selectors";
import { withRouter } from "react-router";
import { getEnabledSectionsMenu } from "Portal/NewPortal/PortalHome/selectors";

const decorate = R.compose(
  connect(
    state => ({
      selectedCategory: homeGetters.selectedCategory(state),
      portal: PortalSelectors.portal(state),
      categories: getEnabledSectionsMenu(state)
    }),
    {
      onCategoryClick: homeActions.navigateTo
    }
  ),
  withRouter
);

const MaterialIcon = ({ icon }) => (
  <i className={`material-icons-outlined ${icon}`} style={{ fontSize: "20px" }}>
    {icon}
  </i>
);

const MenuItem = ({
  icon,
  name,
  isActive,
  onClick,
  avatar,
  rightIcon = false
}) => (
  <div
    style={{
      height: "48px",
      width: "100%",
      padding: "10px 0",
      background: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "6px",
      cursor: "pointer",
      color: isActive ? "#4263EB" : "#1F2937"
    }}
    onClick={onClick}
  >
    <Div display="row.flex-start.center" style={{ gap: "6px" }}>
      {icon && <MaterialIcon icon={icon} />}

      {avatar && <Avatar {...avatar} />}

      <div
        style={{
          fontSize: "16px",
          fontWeight: "600",
          cursor: "pointer"
        }}
      >
        {name}
      </div>
    </Div>
    {rightIcon && <MaterialIcon icon={rightIcon} />}
  </div>
);

const Body = ({
  selectedCategory,
  categories,
  onCategoryClick = noop,
  hideModal = noop,
  isMobileFlyover = false,
  handleClickOpenSwitchEvents = noop,
  portal = {}
}) => {
  let { event = {} } = portal || {};
  let { name = "", id = {} } = event || {};
  return (
    <Div display="column" style={{ gap: "10px", width: "100%" }}>
      <Div display="column" width={1}>
        {R.map(
          ({
            id,
            icon,
            name,
            disabled = false,
            shouldScrollToSection = false
          }) => {
            const isActive = id === selectedCategory;
            if (disabled) {
              return null;
            }
            return (
              <MenuItem
                key={id}
                icon={icon}
                name={name}
                isActive={isActive}
                onClick={() => {
                  onCategoryClick({ id, shouldScrollToSection });
                  hideModal();
                }}
              />
            );
          },
          categories
        )}
      </Div>
      {!isMobileFlyover && (
        <Div
          style={{
            alignSelf: "stretch",
            height: "1px",
            background: "#e7e6ea"
          }}
          width={1}
        />
      )}

      {!isMobileFlyover && (
        <Div display="column" width={1}>
          {/*
          <MenuItem
            icon="settings"
            name="Settings"
            onClick={() => {
              hideModal();
            }}
          />
          <MenuItem
            icon="notifications"
            name="Notifications"
            onClick={() => {
              hideModal();
            }}
          />
          */}
          <MenuItem
            icon={null}
            avatar={{
              name,
              id
            }}
            name={name}
            onClick={handleClickOpenSwitchEvents}
            rightIcon="keyboard_arrow_down"
          />
        </Div>
      )}
    </Div>
  );
};

export default decorate(Body);
